module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.b3ba703c.ttf";